import {Routes} from '@angular/router';
import {
  ApplicantDataComponentConfig,
  ApplicantDataSectionComponent
} from '../common/applicant-data-section/applicant-data-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import {
  DocumentsInformationSectionComponent
} from './sections/documents-information-section/documents-information-section.component';
import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from '../common/agreements-data-section/agreements-data-section.component';
import {SessionService} from '../../../../services/ssession.service';

export const desktopStages: string[] = [
  'Wnioskodawca',
  'Informacja',
  'Zgody',
  'Załączniki'
];

export const mobileStages: string[] = [
  'Wnioskodawca',
  'Informacja',
  'Zgody',
  'Załączniki'
];

export const stages = SessionService.GetUISettings()?.mobileEmbed ? mobileStages : desktopStages;

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages,
  successUrl: '../informacja'
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../informacja',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const documentsInformationDesktopRoutes: Routes = [
  {
    component: ApplicantDataSectionComponent,
    path: 'wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicantDataSectionComponent,
    path: ':appId/wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: DocumentsInformationSectionComponent,
    path: ':appId/informacja',
    data: {
      successUrl: '../zgody'
    }
  },
  {
    path: ':appId/zgody',
    component: AgreementsDataSectionComponent,
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  {path: '', redirectTo: 'wnioskodawca', pathMatch: 'prefix'}
];

export const documentsInformationMobileRoutes: Routes = [
  {
    component: ApplicantDataSectionComponent,
    path: 'wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicantDataSectionComponent,
    path: ':appId/wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: DocumentsInformationSectionComponent,
    path: ':appId/informacja',
    data: {
      successUrl: '../zgody'
    }
  },
  {
    path: ':appId/zgody',
    component: AgreementsDataSectionComponent,
    data: {
      ...agreementsDataSectionConfig,
      removeRegulationsControl: true
    }
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  {path: '', redirectTo: 'wnioskodawca', pathMatch: 'prefix'}
];

export const documentsInformationRoutes: Routes = SessionService.GetUISettings()?.mobileEmbed ? documentsInformationMobileRoutes : documentsInformationDesktopRoutes;
